import React, { useState } from "react";
import "./SocialLinks.css";

const platforms = [
  {
    id: "gmail",
    name: "Gmail",
    username: "JOhnhenry123@gmail.com",
    color: "#1a1a2e",
    logo: (
      <svg viewBox="0 0 48 48" width="42" height="42">
        <path fill="#EA4335" d="M6 10l18 12L42 10v4L24 26 6 14z" />
        <rect fill="#188038" x="6" y="10" width="36" height="28" rx="2" ry="2" opacity="0" />
        <path fill="#4285F4" d="M42 10H6a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h36a2 2 0 0 0 2-2V12a2 2 0 0 0-2-2z" opacity="0.1" />
        <path fill="none" stroke="#EA4335" strokeWidth="2" d="M6 10h36v28H6z" />
        <path fill="#EA4335" d="M6 10l18 12L42 10H6z" />
        <path fill="#fff" d="M6 10l18 12L42 10" opacity="0.3" />
        <path fill="#4285F4" d="M42 10v2L24 24 6 12v-2h36z" opacity="0" />
        <path
          fill="#EA4335"
          d="M44 12.25V36a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V12.25l.87-.58L24 23.06 43.13 11.67l.87.58z"
          opacity="0"
        />
      </svg>
    ),
    logoImg: "https://upload.wikimedia.org/wikipedia/commons/4/4e/Gmail_Icon.png",
    connected: false,
  },
  {
    id: "yahoo",
    name: "Yahoo",
    username: "JOhnhenry",
    color: "#6001D2",
    logoImg: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/36/Yahoo%21_icon.svg/120px-Yahoo%21_icon.svg.png",
    connected: false,
    active: true,
  },
  {
    id: "outlook",
    name: "Outlook",
    username: "JOhnhenry",
    logoImg: "https://upload.wikimedia.org/wikipedia/commons/d/df/Microsoft_Office_Outlook_2019_present.svg",
    connected: false,
  },
  {
    id: "linkedin",
    name: "Connect On LinkedIn",
    username: "JOhnhenry",
    logoImg: "https://upload.wikimedia.org/wikipedia/commons/c/ca/LinkedIn_logo_initials.png",
    connected: false,
  },
  {
    id: "whatsapp",
    name: "Whatsapp",
    username: "8445678987",
    logoImg: "https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg",
    connected: false,
  },
];

const SocialLinks = () => {
  const [selectedPlatform, setSelectedPlatform] = useState("yahoo");
  const [connectedPlatforms, setConnectedPlatforms] = useState({});

  const handleConnect = (id) => {
    setConnectedPlatforms((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <>
      <div className="social-links-wrapper">
        <p className="social-links-title">Social Links</p>
        <div className="social-links-list">
          {platforms.map((platform) => {
            const isSelected = selectedPlatform === platform.id;
            const isConnected = connectedPlatforms[platform.id];
            return (
              <div
                key={platform.id}
                className={`social-link-card${isSelected ? " social-link-card--active" : ""}`}
                onClick={() => setSelectedPlatform(platform.id)}
              >
                <div className="social-link-card__inner">
                  <div className="social-link-card__left">
                    <span className="social-link-card__platform-label">Platform</span>
                    <div className="social-link-card__info">
                      <div className="social-link-card__logo-wrap">
                        <img
                          src={platform.logoImg}
                          alt={platform.name}
                          className="social-link-card__logo"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = `https://ui-avatars.com/api/?name=${platform.name}&background=random&color=fff&size=42`;
                          }}
                        />
                      </div>
                      <div className="social-link-card__details">
                        <span className="social-link-card__name">{platform.name}</span>
                        <span className="social-link-card__username">
                          <span className="social-link-card__username-icon">
                            <i class="fa-regular fa-copy"></i>
                          </span>
                          {platform.username}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="social-link-card__right">
                    <button
                      className={`social-link-card__btn${isConnected ? " social-link-card__btn--connected" : ""}`}
                      onClick={() => {
                        handleConnect(platform.id)
                      }}
                    >
                      {isConnected ? "Disconnect" : "Connect"}
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default SocialLinks;
